var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAnytime1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_46_199)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.3313 34.905C21.3438 37.9725 24.8125 40 28.75 40C34.9562 40 40 34.9588 40 28.75C40 24.8125 37.975 21.3444 34.9062 19.3338C34.9687 18.7313 35 18.1194 35 17.5C35 7.84125 27.1562 0 17.5 0C7.84375 0 0 7.84125 0 17.5C0 27.1588 7.84375 35 17.5 35C18.1187 35 18.7313 34.9675 19.3313 34.905ZM28.75 21.25C32.8875 21.25 36.25 24.6106 36.25 28.75C36.25 32.8894 32.8875 36.25 28.75 36.25C24.6125 36.25 21.25 32.8894 21.25 28.75C21.25 24.6106 24.6125 21.25 28.75 21.25ZM31.175 25.5494L27.5 29.2231L26.325 28.0494C25.5937 27.3175 24.4063 27.3175 23.675 28.0494C22.9438 28.7806 22.9438 29.9694 23.675 30.7006L26.175 33.2006C26.9063 33.9331 28.0937 33.9331 28.825 33.2006L33.825 28.2006C34.5562 27.4694 34.5562 26.2806 33.825 25.5494C33.0937 24.8175 31.9063 24.8175 31.175 25.5494ZM13.825 23.8256L18.825 18.8256C19.175 18.4744 19.375 17.9975 19.375 17.5V7.5C19.375 6.465 18.5375 5.625 17.5 5.625C16.4625 5.625 15.625 6.465 15.625 7.5V16.7231L11.175 21.1744C10.4438 21.9056 10.4438 23.0944 11.175 23.8256C11.9063 24.5575 13.0937 24.5575 13.825 23.8256Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_46_199"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnytime1);
export default __webpack_public_path__ + "static/media/anytime1.3ec222433210b05825050e46a0f31941.svg";
export { ForwardRef as ReactComponent };